export default __webpack_public_path__ + "static/media/025-cone.28004300.svg";